var HTTPS_RESOURCE_PATTERN = /^https:\/\//;

function isHttpsResource(uri) {
  return HTTPS_RESOURCE_PATTERN.test(uri);
}

module.exports = isHttpsResource;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/utils/is-https-resource.js
// module id = 2327
// module chunks = 0